import { render, staticRenderFns } from "./rubbishSortList.vue?vue&type=template&id=74597a94&scoped=true&"
import script from "./rubbishSortList.vue?vue&type=script&lang=js&"
export * from "./rubbishSortList.vue?vue&type=script&lang=js&"
import style0 from "./rubbishSortList.vue?vue&type=style&index=0&id=74597a94&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74597a94",
  null
  
)

export default component.exports